import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import modules from './modules';

Vue.use(Vuex);

// Reducer: Only save rulebase and log state
// Filter: Only save when preselect work
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({ persist: state.persist }),
  filter: (mutation) => mutation.type === 'persist/setPreSelectRuleSetId'
    || mutation.type === 'persist/setPreSelectRuleId'
    || mutation.type === 'persist/setUnreadLogChannelList'
    || mutation.type === 'persist/setUserUnreadValue'
  ,
});

export default new Vuex.Store({
  modules,
  plugins: [vuexLocal.plugin],
});
